import UploadProgressBox from "@/features/upload-progress-box/UploadProgressBox";
import { useTenant } from "@/providers/session";
import { useTranslation } from "react-i18next";
import { ReceivablesTable } from "./receivables-table";
import { ReceivablesUploadBox } from "./upload-box";

export default function Receivables() {
  const { tenantId } = useTenant();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 h-full">
      <p className="text-muted-foreground text-sm font-medium">
        {t("receivables.guiding_title")}
      </p>
      <ReceivablesUploadBox tenantId={tenantId} />
      <ReceivablesTable tableName="receivables" />
      <UploadProgressBox />
    </div>
  );
}
